var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-add-form" },
    [
      _c(
        "modal",
        {
          attrs: {
            title: "Créer une conversation",
            size: "md",
            "ok-text": "Envoyer invitation",
            "cancel-text": "Annuler"
          },
          model: {
            value: _vm.opened,
            callback: function($$v) {
              _vm.opened = $$v
            },
            expression: "opened"
          }
        },
        [
          _vm.form != null
            ? _c("form", [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "adding-form-name" } }, [
                    _vm._v(
                      "Nom de la conversation (Laisser vide pour liste des participants)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.chatroom_name,
                        expression: "form.chatroom_name"
                      }
                    ],
                    ref: "adding-form-name",
                    staticClass: "form-control w-100",
                    attrs: {
                      id: "adding-form-name",
                      type: "text",
                      placeholder: "Nom du chatroom..."
                    },
                    domProps: { value: _vm.form.chatroom_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "chatroom_name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Liste des participants")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    _vm._l(_vm.form.participants, function(participant, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "participant-item p-2 mb-2"
                        },
                        [
                          _c("div", { staticClass: "flex-grow-1" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(participant.user_name) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            index > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn red btn-sm",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.deleteParticipant(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-trash" })]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("select-2", {
                        ref: "select-2",
                        staticClass: "mx-1",
                        attrs: {
                          placeholder: "Choisir un utilisateur",
                          endpoint: _vm.userSelect2Endpoint,
                          dropdownParent: ".modal-add-form .modal-dialog",
                          attributes: { selected_users: _vm.selectedUserIds }
                        },
                        on: {
                          selected: function($event) {
                            return _vm.userSelected($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "btn",
                {
                  on: {
                    click: function($event) {
                      _vm.opened = false
                    }
                  }
                },
                [_vm._v("Annuler")]
              ),
              _vm._v(" "),
              _c(
                "btn",
                {
                  attrs: { type: "primary", disabled: _vm.confirming },
                  on: { click: _vm.confirm }
                },
                [_vm._v("Créer la conversation")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }